import { permissionsComparator } from '../../utils/comparators';
import { Permissions } from '../../shared/constants/permissions';

interface Permission {
  key: string;
  displayOrder: number;
}

export const mutatePermissions = (permissions: Permission[]): Permission[] => permissions.sort(permissionsComparator);

export const filterPermissions = (permission: Permission): boolean => {
  // The 'whitelist' permission isn't displayed in the normal way

  return permission.key !== Permissions.Whitelist;
};
